import Vue from 'vue'
import { create } from 'vue-modal-dialogs'

import Alert from './common/Alert'
import Confirm from './common/Confirm'
Vue.prototype.$alert = create(Alert, 'title', 'message')
Vue.prototype.$confirm = create(Confirm)

import ImageCropper from './ImageCropper'
export let cropImage = create(ImageCropper, 'title', 'file', 'callback')

import AddTestEnv from './AddTestEnv'
export let addTestEnv = create(AddTestEnv)

import RenameEnvironment from '@/views/apps/Environment/RenameModal'
export let renameEnvironment = create(RenameEnvironment, 'envName', 'envId')

import ClientConfig from './ClientConfig'
export let clientConfig = create(ClientConfig, 'config')

import FalsePositive from './FalsePositive'
export let falsePositive = create(FalsePositive, 'finding')

import AddModelsToMiddleware from './AddModelsToMiddleware'
export let addModelsToMiddleware = create(AddModelsToMiddleware)

import SelectEnvironment from '@/views/apps/modals/SelectEnvironment'
export let selectEnvironment = create(SelectEnvironment, 'environments')

import TwoFactorSetup from '@/views/account/modals/TwoFactorSetup'
export let twoFactorSetup = create(TwoFactorSetup)